import { getShellApiInstance } from './shell-api-instance'

export const getShellAuth = () => getShellApiInstance()?.auth

export const getToken = () => getShellAuth()?.getToken()
